const get = function (compareFrom, stackedItems) {
    for (let stackedItem in stackedItems) {
        stackedItem = stackedItems[stackedItem];

        const value = stackedItem[stackedItem.length - 1];

        if (stackedItem.length == 1) {
            return value;
        }

        for (let compareTo in stackedItem) {
            compareTo = stackedItem[compareTo];

            if (compareFrom === compareTo) {
                return value;
            }
        }
    }

    return false;
};

export default {
    get,
};
